import React from "react";
import { AdvantageList } from "../../blocks/advantage-list";
import { CommonPageLink } from "../../blocks/common-page-link";
import { useTranslation } from "react-i18next";
import { Header } from "../../components/Header";
import { GuardBanner } from "../../blocks/guard-banner";
import { Footer } from "../../components/FooterV2";
import { HomeTryOn } from "../../blocks/home-try-on";
import { GuardFeature } from "../../blocks/guard-feature";
import { GuardCard } from "../../blocks/guard-card";
import "./styles.less";
import { ProductBanner } from "../../blocks/product-banner";
import { Helmet } from "react-helmet";
import { Notice } from "../../components/Notice";
export const GuardPage = () => {
  const bannerData = {
    title: "learn.guard.banner.title",
    subTitle: "learn.guard.banner.subtitle",
    bannerImg: {
      src: "//files.authing.co/authing-website/guard-banner-img-v2.png",
      alt: "开发登录SDK/API",
    },
    bannerBG: {
      src: "//files.authing.co/authing-website/sso-banner-bg.png",
      alt: "authing",
    },
    hasButton: true,
    docLink: "https://docs.authing.cn/v2/reference/ui-components/",
  };
  const advantageData = [...Array(3)].map((item, index) => {
    return {
      label: `learn.guard.advantageData.${index}.label`,
      value: `learn.guard.advantageData.${index}.value`,
    };
  });
  const { t } = useTranslation();
  const pagesLink = [
    {
      title: t("common.pageLink.sso.title"),
      description: t("common.pageLink.sso.description"),
      imgurl: "/page-link-comp.png",
      jumpLink: "/learn/sso",
      defaultImg: "//files.authing.co/authing-website/page-link-icon-comp.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-comp.svg",
    },
    {
      title: t("common.pageLink.mfa.title"),
      description: t("common.pageLink.mfa.description"),
      imgurl: "/page-link-mfa.png",
      jumpLink: "/mfa",
      defaultImg: "//files.authing.co/authing-website/page-link-icon-mfa.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-mfa.svg",
    },
    {
      title: t("common.pageLink.verify.title"),
      description: t("common.pageLink.verify.description"),
      imgurl: "/page-link-verify.png",
      jumpLink: "/verify",
      defaultImg:
        "//files.authing.co/authing-website/page-link-icon-verify.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-verify.svg",
    },
    {
      title: t("common.pageLink.database.title"),
      description: t("common.pageLink.database.description"),
      imgurl: "/page-link-database-connection.png",
      jumpLink: "/database-connection",
      defaultImg:
        "//files.authing.co/authing-website/page-link-icon-database.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-database.svg",
    },
  ];
  const GuardCardDataTop = {
    image: "//files.authing.co/authing-website/guard-framework-img-v2.png",
    alt: "低代码实现登录框",
    title: t("learn.guard.freamwork.title"),
    subTitle: t("learn.guard.freamwork.subtitle"),
    content: t("learn.guard.freamwork.descript"),
  };
  const GuardCardDataBottom = {
    image: "//files.authing.co/authing-website/guard-flexibility-img-v2.png",
    alt: "自定义登录样式和登录框",
    title: t("learn.guard.flexibility.title"),
    subTitle: t("learn.guard.flexibility.subtitle"),
    content: t("learn.guard.flexibility.descript"),
  };
  return (
    <div className="guard-page">
      <Helmet>
        <title>
          通用登录组件-登录表单-社会化登录--Authing身份云以开发者为中心
        </title>
      </Helmet>
      <Header mode="light" hasNotice />
      <ProductBanner {...bannerData} />
      {/* <GuardBanner {...bannerData} /> */}
      <AdvantageList advantageData={advantageData} position="bottom" />
      <GuardCard {...GuardCardDataTop} />
      <GuardFeature />
      <GuardCard {...GuardCardDataBottom} />
      <CommonPageLink pagesLink={pagesLink} />
      <div className="guard-homeTryOn-bg">
        <HomeTryOn />
      </div>
      <Footer />
    </div>
  );
};
